import React, { useState, useEffect } from 'react';
import FarmMap from './FarmMap';
import Dashboard from './Dashboard'; // ✅ Import the Dashboard component

function App() {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    try {
      // Simulate any error-checking if needed
    } catch (err) {
      console.error('Error loading FarmMap:', err);
      setHasError(true);
    }
  }, []);

  return (
    <div style={{ height: '100vh', width: '100%', padding: '1rem', overflow: 'auto' }}>
      <h1 style={{ marginBottom: '1rem' }}>🚜 Farm Monitoring Dashboard</h1>
      
      {/* Render Dashboard component */}
      <Dashboard />

      {/* Render FarmMap or show error */}
      {hasError ? (
        <div style={{ color: 'red' }}>❌ Error loading map</div>
      ) : (
        <FarmMap />
      )}
    </div>
  );
}

export default App;
